#import "../fragments/meeting-fragment.graphql"

mutation DeleteMeeting($input: MeetingDeleteInput!) {
    meetingDelete(input: $input) {
        meeting {
            ...MeetingFragment
        }
    }
}
